import { INotification, INotificationWsMessage } from '@/services/Notification/notifications.types.ts'
import css from './notificationCenterCard.module.css'
import NotificationIcon from '@/services/Notification/components/NotificationIcon'
import NotificationDescription from '@/services/Notification/components/NotificationDescription'
import NotificationTitle from '@/services/Notification/components/NotificationTitle'
import timeUtils from '@/utils/time.utils.ts'
import NotificationCenterActions from '../NotificationCenterActions'
import { forwardRef } from 'react'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types.ts'
import { NotificationIconColors } from '@/services/Notification/components/NotificationIcon/NotificationIconColors.enum.ts'
import cn from '@/utils/cn.ts'
import BadgeStatus from '@/shared/Badges/BadgeStatus'

interface IProps {
  notification: INotification | ISystemEvent
  active?: boolean
}

const NotificationCenterCard = forwardRef<HTMLDivElement, IProps>((props, ref) => {
  const getNotificationColor = (): NotificationIconColors => {
    if (props.notification.type === 'LP_ERROR') {
      if (props.notification.payload.flag === 'WARNING') {
        return NotificationIconColors.WARNING
      }
    }

    return null
  }

  const renderNotificationTitle = () => {
    return (
      <div className="flex-space-between">
        <span className={cn(props.active ? 'text-nm-bold' : 'text-nm', 'text-pre')}>
          <NotificationTitle notification={props.notification} />
        </span>
        {props.active && <BadgeStatus type="blue" style={{ marginRight: '-16px' }} />}
      </div>
    )
  }

  return (
    <div ref={ref} className={css.wrapper}>
      <div className={css.icon}>
        <NotificationIcon iconColor={getNotificationColor()} notification={props.notification} />
      </div>
      <div className="inline-flex-gap top width100">
        <div className="flex-lines gap4 width100">
          {renderNotificationTitle()}
          <p className="text-nm text-description" style={{ whiteSpace: 'pre-line' }}>
            <NotificationDescription notification={props.notification as INotificationWsMessage} />
          </p>
          {props.notification.createdAt && (
            <div className="text-sm text-description mt8">{timeUtils.timeAgo(props.notification.createdAt)}</div>
          )}
          <div className="mt12">
            <NotificationCenterActions notification={props.notification} />
          </div>
        </div>
      </div>
    </div>
  )
})

export default NotificationCenterCard
